import { IconButton } from '@mui/material'
import { SearchIcon } from '$common/icons'

interface Props {
  onClick: () => any
}

// TODO: check to replace this component in appbars
export function SearchButton({ onClick }: Props) {
  return (
    <IconButton sx={{ padding: 1, color: 'neutral700' }} onClick={onClick}>
      <SearchIcon />
    </IconButton>
  )
}
